import styled from '@emotion/styled'
import { bkgdDecorObjectBlue, bkgdPatternWave } from '.'

export const InteractiveSectionWrapper = styled.section`
  display: grid;
  background-color: #B5D7FF;
  background-image: url(${bkgdDecorObjectBlue});
  background-size: contain;
`

export const DualLangEnglish = styled.div<{ isMobile?: boolean }>`
  display: grid;
  grid-template-columns: ${({ isMobile }) => (isMobile ? 'auto' : 'auto auto')};
  grid-column-gap: 10px;
`

export const CollageContainer = styled.div`
  display: grid;
  justify-self: center;
  padding: 32px 0;

  @media (max-width: 767px) { padding: 32px 24px; }
`

export const Collage = styled.img`
  height: 425px;
  grid-column: 1;
  grid-row: 1;

  @media (max-width: 970px) { height: 325px; }
  @media (max-width: 767px) { height: unset; width: 500px; }
`

export const Mari = styled.img`
  position: relative;
  height: 125px;
  justify-self: end;
  grid-column: 1;
  grid-row: 1;
  bottom: 120px;
`

const waveMargin = '25px'

export const Wave = styled.div<{ bottom?: boolean }>`
  background-image: url(${bkgdPatternWave});
  background-size: cover;
  background-position: 0% 100%;
  height: calc(100vw / 6);
  transform: ${({ bottom }) => (bottom ? 'rotate(180deg)' : '')};
  margin-top: ${({ bottom }) => (bottom ? waveMargin : '0')};
  margin-bottom: ${({ bottom }) => (bottom ? '-1px' : waveMargin)}; // -1px to avoid blue background glitching on resizing/movement
`
